'use client'
import { PortableText } from '@portabletext/react'
import { getPortableTextComponents } from 'app/components/PortableTextComponents'
import { useState } from 'react'

interface Props {
  blocks: any
}

export default function KunnskapshullBody({ blocks }: Props) {
  const [, setHeadingInView] = useState<string | undefined>()

  const handleInView = (inView: boolean, entry: IntersectionObserverEntry) => {
    if (inView) {
      setHeadingInView(entry.target.children[0].id)
    }
  }
  return (
    <main className="mx-auto max-w-5xl px-4 py-16 md:px-8 print:break-before-all ">
      <h1 className="mb-2 text-2xl font-semibold md:text-3xl lg:text-4xl print:text-4xl">
        <span className="hidden print:inline-block">9. </span>Kunnskapshull
        knyttet til fiskevelferd ved bruk av brønnbåt
      </h1>
      <PortableText
        value={blocks}
        components={getPortableTextComponents(handleInView)}
      />
    </main>
  )
}
